module.exports = __webpack_public_path__ + "img/galeria-aquicultura-3.7b5608a4.jpg";